import React, { FC } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useFetchProject, useFetchArea } from 'services/project'
import { useLayersWidgets } from 'services/widget'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Logo } from 'features/shared/Logo'
import { AreaTypeDetails } from 'components/AreaTypeDetails'
import { ReportWidget } from './components/ReportWidgets'
import { Badge } from 'components/Badge'
import { Flex } from 'components/Flex'
import { Text } from 'components/Text'
import { Icon } from 'components/Icon'
import { getAreaIcon } from 'utils/areaDetails'
import styles from './ProjectReport.module.scss'

// TODO: Replace with the real image


export const ProjectReport: FC = (_props) => {
  const { projectId } = useParams()
  const [searchParams] = useSearchParams()
  const { project } = useFetchProject(projectId)
  const areaId = searchParams.get('areaId') || ''
  const { area } = useFetchArea(projectId, areaId)
  const { widgets, status } = useLayersWidgets(project?.activeLayers || [])

  if (!project || (areaId && !area)) return null
  if (status === 'loading' || !widgets) return null

  let iscompare = null
  areaId ? iscompare = true : iscompare = false

  if (iscompare) {
    console.log("es reporte comparativo")
    fetch(`https://mapserver.descifra.global/getImageCompare?projectId=${projectId}&areaId=${areaId}`)
  }
  else {
    console.log("no es comparativo" + project.imageUrl)
    let divs = document.querySelectorAll(`div`);

    divs.forEach(function (div) {
      console.log(div);
      if (div.style.visibility === "hidden") {

        div.remove();
      }
    });


  }


  return (
    <div className={styles.projectReport}>
      <Stack space="xlarge">
        <Stack space="small">
        </Stack>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td> <Logo /></td>
              <td><Heading size="main">{project.name}</Heading>

              </td>
              <td>
                <Flex gap="sm" align="center" className={styles.compareArea}>
                  <Badge color={styles.primary}>
                    <AreaTypeDetails project={project} />
                  </Badge>
                  {area && (
                    <>
                      <Icon name="add-line" className={styles.icon} />
                      <Badge color={area.color}>
                        <Flex gap="sm" align="center" className={styles.compareArea}>
                          <Icon name={getAreaIcon(area.areaType)} />
                          <Text component="span" size="small" weight="strong" truncate>
                            {area.name}
                          </Text>
                        </Flex>
                      </Badge>
                    </>
                  )}
                </Flex>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <div className={styles.map} >
            <img src={iscompare ? project.imageUrl.replace(".png", `_${areaId}.png`) : project.imageUrl} alt="" />
          </div>
          <table>
            <tbody>
              <tr>
                <td>
                  <div className={styles.widgets}>
                    {widgets.map((widget, index) => {
                      return (

                        <React.Fragment key={`widget-${widget.id}`}>
                          {(index === 4 || index % 6 === 4) && <p className={styles.pageBreak} />}
                          <ReportWidget widget={widget} projectId={projectId} areaId={areaId} />
                        </React.Fragment>

                      )
                    })}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Stack>
    </div>


  )
}

ProjectReport.displayName = 'ProjectReport'
